import { Location } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "@services/session.service";
import { StateService } from "@services/state.service";
import { TerminologiaService } from "@services/terminologia.service";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";

@Component({
	selector: "app-home",
	templateUrl: "./home.component.html",
	styleUrls: ["./home.component.scss"],
})
export class HomeComponent extends BaseFuncionalidadComponent {
	constructor(
		sessionService: SessionService,
        router: Router,
        route: ActivatedRoute,
        location: Location,
        stateService: StateService,
        private terminologiaService: TerminologiaService
	) {
		super(route, sessionService, location, router, stateService);
	}

	// el usuario esta logueado
	get isAuthenticated(): boolean {
		return this.sessionService.isAuthenticated();
	}

	// maneja cual es el perfil seleccionado actualmente por el usuario
	get rolActual() {
		return this.sessionService.rolActual;
	}

	// maneja el nombre del usuario que inicio sesion
	get nombreUsuario(): string {
		return this.sessionService.getSesionActual().getNombreCompleto();
	}

    get nombreRolSeleccionado(): string {
        const rol = this.terminologiaService.obtenerRolPorID(this.sessionService.rolActual);
        return rol ? rol.nombre : '';
    }
}
